import { useEffect } from 'react'
import { toast, TypeOptions } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

export const useToastAutoClose = (
  isCompleted: boolean,
  toastTimestamp: number,
  type?: TypeOptions | null | undefined,
) => {
  useEffect(
    function autoClose() {
      let timerId: NodeJS.Timeout

      if (isCompleted) {
        toast.update(toastTimestamp, {
          type: type || toast.TYPE.SUCCESS,
          autoClose: 5000,
        })
      }

      return () => {
        clearTimeout(timerId)
      }
    },
    [isCompleted, toastTimestamp],
  )
}
